import { store } from 'app/store';
import { GameWeek, ITeamStandings } from 'types';

export type TeamStatsLoaderPayload = {
  year: number;
  weekNum: GameWeek;
  seasonStandings: ITeamStandings[];
};

export const teamStatsLoader = async ({ params }: any): Promise<TeamStatsLoaderPayload | Response> => {
  const yearId = params.yearId;
  const weekId = params.weekId;

  // const msg = `${Emojis.eyes} %c teamStatsLoader %c %c ${yearId} %c %c ${weekId} %c`;
  // console.log(msg, LocationCls, '', ValueCls, '', ValueCls, '');

  // const msg = `${Emojis.eyes} %c teamStatsLoader %c %c ${location.href} %c`;
  // console.log(msg, LocationCls, '', ValueCls, '');

  const seasonStandings: ITeamStandings[] = store.getState().stats.seasonStandings;

  return {
    year: yearId,
    weekNum: weekId,
    seasonStandings,
  };
};
